(() => {
  const ELEMENT_NAME = 'complementary-products';

  class ComplementaryProducts extends HTMLElement {
    observer = undefined;

    connectedCallback() {
      this.initProductRows();

      if (this.dataset.loaded === 'true') return;

      if (this.querySelector('.complementary-products__item')) {
        this.dataset.loaded = 'true';
        return;
      }

      this.initializeRecommendations(this.dataset.productId);
    }

    initializeRecommendations(productId) {
      this.observer?.unobserve(this);
      this.observer = new IntersectionObserver(
        (entries, observer) => {
          if (!entries[0].isIntersecting) return;
          observer.unobserve(this);
          this.loadRecommendations(productId);
        },
        { rootMargin: '0px 0px 400px 0px' }
      );
      this.observer.observe(this);
    }

    loadRecommendations(productId) {
      const { url, sectionId, blockId } = this.dataset;
      if (!url || !sectionId || !productId) return;

      fetch(`${url}&product_id=${productId}&section_id=${sectionId}`)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const source = html.querySelector(
            `${ELEMENT_NAME}[data-block-id="${blockId}"]`
          );

          if (!source?.innerHTML.trim().length) {
            this.remove();
            return;
          }

          this.innerHTML = source.innerHTML;
          this.dataset.loaded = 'true';
          this.initProductRows();
        })
        .catch(error => {
          console.error(error);
          this.remove();
        });
    }

    initProductRows() {
      window.theme?.initInlineProductRows?.(this);
    }
  }

  if (!customElements.get(ELEMENT_NAME)) {
    customElements.define(ELEMENT_NAME, ComplementaryProducts);
  }
})();
